import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Field, reduxForm, change } from 'redux-form';
import submit from './submit';
import validate from './validate';
import { injectIntl } from 'react-intl';

// Style
import {
  Button,
  FormGroup,
  Col,
  Row,
  Panel,
} from 'react-bootstrap';
import Link from '../../Link';

// Translation
import { FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';
import InputFieldComponent from '../../Common/FormField/InputFieldComponent';
import s from './EditStaticPage.css';
import bt from '../../../components/commonStyle.css';

class EditStaticPage extends React.Component {

  constructor(props) {
    super(props)
    if (typeof window !== 'undefined') {
      this.CustomEditor = require('../../Common/Editor/CustomEditor');
    }
    this.state = { editorHtml: '' } // You can also pass a Quill Delta here

  }

  static propTypes = {
    title: PropTypes.string.isRequired,
    initialValues: PropTypes.object,
  };

  renderQuill = ({ input, label, type, meta: { touched, error }, className, placeholder }) => {
    const { Editor } = this.CustomEditor;
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <Editor
          {...input}
          placeholder={placeholder}
        />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    )
  }

  render() {
    const { error, handleSubmit, submitting, dispatch, initialValues } = this.props;
    const { parentData } = this.props;
    const gobackcss = { padding: '10px' };
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <h1 className={s.siteAdminHeading}> <FormattedMessage {...messages.editPageDetails} /></h1>
        <Row>
          <Col xs={12} sm={12} md={12} lg={8} className={s.blockCenter}>
            <div className={cx(s.space4, 'singleButtonFlexEnd')}>
              <Link to={"/siteadmin/staticpage/management"} className={cx(bt.btnPrimaryBorder, bt.btnLarge, bt.noTextDecoration)}>
                <FormattedMessage {...messages.goBack} />
              </Link>
            </div>
            <Panel className={cx(s.panelHeader)}>
              <form onSubmit={handleSubmit(submit)}>
                {error && <strong>{formatMessage(error)}</strong>}
                <Field name="metaTitle"
                  type="text"
                  component={InputFieldComponent}
                  label={formatMessage(messages.metaTitleLabel)}
                  placeholder={formatMessage(messages.metaTitlePlaceHolder)}
                  inputClass={bt.commonControlInput}
                  formGroupClass={bt.space4} />

                <Field name="metaDescription"
                  inputClass={bt.commonControlTextArea}
                  formGroupClass={bt.space4}
                  componentClass={'textarea'}
                  component={InputFieldComponent}
                  label={formatMessage(messages.metaDescriptionLabel)}
                  placeholder={formatMessage(messages.metaDescriptionPlaceHolder)} />

                <FormGroup className={bt.space3}>
                  <label className={s.labelTextNew} ><FormattedMessage {...messages.contentLabel} /></label>
                  <Field name="content" component={this.renderQuill} placeholder={formatMessage(messages.contentPlaceHolder)} />
                </FormGroup>
                <div className='singleButtonFlexEnd'>
                  <Button bsSize="small" className={cx(bt.btnPrimary, bt.btnLarge)} type="submit" disabled={submitting} >
                    <FormattedMessage {...messages.save} />
                  </Button>
                </div>
              </form>
            </Panel>
          </Col>
        </Row>
      </div>
    )
  }
}

EditStaticPage = reduxForm({
  form: 'EditStaticPage', // a unique name for this form
  validate
})(EditStaticPage);



const mapState = (state) => ({});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(EditStaticPage)));